export const normalizeSearchText = (value) =>
  value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim()
